import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { RaiseRiskComponent } from './components/raise-risk/raise-risk.component';
import { MyRiskDashboardComponent } from './components/my-risk-dashboard/my-risk-dashboard.component';
import { RaiseRiskMOCComponent } from './components/raise-risk-moc/raise-risk-moc.component';
import { RaiseRiskJSAComponent } from './components/raise-risk-jsa/raise-risk-jsa.component'; 
import { RaiseRiskHEMPComponent } from './components/raise-risk-hemp/raise-risk-hemp.component'; 
import { RaiseRiskHAZOPComponent } from './components/raise-risk-hazop/raise-risk-hazop.component'; 
import { RaiseRiskHAZIDComponent } from './components/raise-risk-hazid/raise-risk-hazid.component'; 
import { RiskPendingApprovalComponent } from './components/risk-pending-approval/risk-pending-approval.component';
const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'raise-risk/:riskId'
  },
  {
    path: 'raise-risk/new',
    component: RaiseRiskComponent
  },
  {
    path: 'raise-risk/:riskId',
    component: RaiseRiskComponent
  },
  {
    path: 'risk-overview',
    component: MyRiskDashboardComponent
  },
  {
    path: 'risk-Approval',
    component: RiskPendingApprovalComponent
  },
  {
    path: 'raise-risk-moc/new',
    component: RaiseRiskMOCComponent
  },
  {
    path: 'raise-risk-moc/:riskId',
    component: RaiseRiskMOCComponent
  },
  {
    path: 'raise-risk-jsa/new',
    component: RaiseRiskJSAComponent
  },
  {
    path: 'raise-risk-jsa/:riskId',
    component: RaiseRiskJSAComponent
  },
  {
    path: 'raise-risk-hemp/new',
    component: RaiseRiskHEMPComponent
  },
  {
    path: 'raise-risk-hemp/:riskId',
    component: RaiseRiskHEMPComponent
  },
  {
    path: 'raise-risk-hazop/new',
    component: RaiseRiskHAZOPComponent
  },
  {
    path: 'raise-risk-hazop/:riskId',
    component: RaiseRiskHAZOPComponent
  },
  {
    path: 'raise-risk-hazid/new',
    component: RaiseRiskHAZIDComponent
  },
  {
    path: 'raise-risk-hazid/:riskId',
    component: RaiseRiskHAZIDComponent
  },
  {
    path: 'risk-overview',
    component: MyRiskDashboardComponent
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule],
})
export class RiskRoutingModule { }
